module.exports = __webpack_public_path__ + "img/3.f40298d9.jpg";